module.exports = __webpack_public_path__ + "static/media/herings_logo_text.86c87312.png";